export default "__VITE_ASSET__DxWRxac0__"